import { render, staticRenderFns } from "./NavbarArabic.vue?vue&type=template&id=39f2d040&scoped=true&"
import script from "./NavbarArabic.vue?vue&type=script&lang=js&"
export * from "./NavbarArabic.vue?vue&type=script&lang=js&"
import style0 from "./NavbarArabic.vue?vue&type=style&index=0&id=39f2d040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2d040",
  null
  
)

export default component.exports